import React, { useEffect, useState } from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, Checkbox } from '@mui/material'
import { FilterInput } from '../../common/filterInput'
import DropDownOA from '../../common/dropDownOA'
import LineInputV3 from '../../common/lineInputV3'
import { cellStyles, headCellStyles, paymentTypeStyles, rankFilteredRows } from './const'
import { focusElemnt, getPaymentTypeBackground, isValueinObjectArray } from '../../common/helper'
import { getColumnDefsTwo } from './DeliveryMemoTableDefs'
import { useTranslation } from '../../../i18n/I18nProvider'
import { GUJRAT_COMPANY_ID, LALA_EXPRESS, SAMAY_TRAVEL, TULSI_TRAVEL } from '../../../helper/companyIdhardcode'

const DeliveryMemoTableTwo = (props) => {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const columnDefsTwo = getColumnDefsTwo(translations)
  const { data, methods } = props;
  const { tableData, driverInfo, brnchList,
    vehicleList, showMore, loginData } = data
  const isGujaratCompany = loginData?.intCompanyID === GUJRAT_COMPANY_ID
  const showSenderColumns = [LALA_EXPRESS, SAMAY_TRAVEL, TULSI_TRAVEL].includes(loginData?.intCompanyID)
  const visibleColumnDefsTwo = columnDefsTwo.filter((col) => !col.showIf || col.showIf({ isGujaratCompany, showSenderColumns }))
  const getColWidth = (col) => (isGujaratCompany && col.gtWidth ? col.gtWidth : col.width)
  const theme = useTheme()
  const { palette: cs } = theme
  const [calcwidth1, setWidth1] = useState(0)
  const [calcwidth2, setWidth2] = useState(0)
  const [filterValues, setFilterValues] = useState({});
  const [filteredData, setfilteredData] = useState(tableData)
  const { bulkDeliveryCheck = false, } = data;
  useEffect(() => setfilteredData(tableData), [tableData])
  const handleChangeContain = (e, name) => {
    let value = e.target.value;
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value
    }));
  }
  useEffect(() => {
    const filteredDataTemp = tableData.filter((item) => {
      return visibleColumnDefsTwo.every((column) => {
        const filterValue = filterValues[column.field] || "";
        if (!filterValue) return true
        const value = column.field === 'Sender'
          ? `${item.Sender || ''} ${item.SenderMobileNo || ''}`
          : item[column.field]
        return value && value.toString().toLowerCase().includes(filterValue.trim().toLowerCase())
      })
    })
    setfilteredData(rankFilteredRows(filteredDataTemp, filterValues, { combinedSender: true }))
  }, [filterValues])
  const chkBoxNavigation = (e, nextId, prevId) => {
    if (e.key === 'ArrowUp') {
      focusElemnt(prevId)
    }
    if (e.key === 'ArrowDown') {
      focusElemnt(nextId)
      e.preventDefault()
    }
    if (e.key === 'Enter') {
      focusElemnt('memoBrnchForDeliveryTransfer')
      e.preventDefault()
    }
  }
  return (<>
    <TableContainer
      className="delivery-memo-table scroll"
      component={Paper}
      sx={{ border: '1px solid #aeaeae', borderRadius: '8px', height: showMore ? 'calc( 50vh - 120px)' : 'calc( 70vh - 100px)', overflow: 'auto', margin: '0px 0px 0px 5px' }}
    >
      <Table aria-label="a dense table" id='delivery-memo-tbl-two' sx={isGujaratCompany ? { tableLayout: 'fixed', width: '100%' } : undefined}>
        <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', background: cs.primary.main, zIndex: 2 }}>
          <TableRow>
            <TableCell style={{ ...headCellStyles, width: isGujaratCompany ? '3%' : '2%', textAlign: 'center', borderTopLeftRadius: '8px' }}>
              <Checkbox id="memoTableHeadCheck" style={{ color: 'white' }} />
            </TableCell>
            {visibleColumnDefsTwo.map((col, i) => (
              <TableCell
                key={col.field || i}
                style={{
                  ...headCellStyles,
                  width: getColWidth(col),
                  backgroundColor: '#0086ff',
                  ...(i === visibleColumnDefsTwo.length - 1 ? { borderTopRightRadius: '8px' } : {})
                }}
              >
                  {col.headerName.split('\n').map((line, j, arr) => (
                    <React.Fragment key={j}>{line}{j < arr.length - 1 && <br />}</React.Fragment>
                  ))}
              </TableCell>
            ))}
          </TableRow>
          <TableRow style={{ position: 'sticky', top: '0', zIndex: 3, background: '#fff' }}>
            <TableCell style={{ ...cellStyles, textAlign: 'center', width: isGujaratCompany ? '3%' : '2%' }}>
              <Checkbox id="memoFilterCheck" sx={{
                color: "#ffffff",
                "&.Mui-checked": {
                  color: "#ffffff",
                },
              }} style={{ '&$checked': { color: '#ffffff' } }} />
            </TableCell>
            {visibleColumnDefsTwo.map((col, i) => (
              <TableCell key={col.field || i} style={cellStyles}>
                <Box>
                  <FilterInput label={dm.contains || 'Contains'} marginB={true} disabled={col.disableFilter} onChange={col.disableFilter ? undefined : (e) => handleChangeContain(e, col.field)} />
                </Box>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((el, index) => (
            <DeliveryMemoRow key={'table-memo' + index} index={index} data={el} cs={cs} calcwidth1={calcwidth1} calcwidth2={calcwidth2} driverInfo={driverInfo} brnchList={brnchList} vehicleList={vehicleList}
              propData={data} methods={methods} chkBoxNavigation={chkBoxNavigation} filteredData={filteredData} isGujaratCompany={isGujaratCompany} showSenderColumns={showSenderColumns} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
  )
}
const DeliveryMemoRow = (props) => {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const { cs, index, data, driverInfo, brnchList, vehicleList, chkBoxNavigation, filteredData, isGujaratCompany, showSenderColumns } = props
  const { propData, methods } = props;
  const { selectedLrs, loginData } = propData
  const { updateSelectedList1 } = methods
  const [branchListData, setBranchListData] = useState([])
  const isChecked = isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')
  const [transferVehicle, setTransferVehicle] = useState('')
  const [delBranch, setDelBranch] = useState('')
  const [transDriverName, setTransDiverName] = useState('')
  const {
    bulkDeliveryCheck = false,
    brnchForDelivery,
    trnsfrVehicle,
    driverName,
    remark,
  } = isChecked ? propData : {}
  const { setSelectedLrs,
    setBrnchForDelivery, setTrnsfrVehicle,
    setDriverName, setRemark } = methods
  const isDisabled = bulkDeliveryCheck || !isChecked

  useEffect(() => {
    let newList = brnchList.filter((item) => item.BranchID !== loginData.intBranchID)
    setBranchListData(newList)
  }, [brnchList])

  useEffect(() => {
    if (brnchForDelivery !== '') {
      setDelBranch(brnchForDelivery)
    } else {
      setDelBranch(' ')
    }
  }, [brnchForDelivery])
  useEffect(() => {
    if (trnsfrVehicle !== '') {
      setTransferVehicle(trnsfrVehicle)
    } else {
      setTransferVehicle(' ')
    }
  }, [trnsfrVehicle])
  useEffect(() => {
    if (driverName !== '') {
      setTransDiverName(driverName)
    } else {
      setTransDiverName(' ')
    }
  }, [driverName])
  return (
    <TableRow>
      <TableCell style={{ ...cellStyles, textAlign: 'center', border: 'none', borderBottom: '1px solid #ddd', width: isGujaratCompany ? '3%' : '2%' }}>
        <Checkbox
          id={'memoTablerowCheck' + index}
          onChange={(e) => updateSelectedList1(e, data, selectedLrs, setSelectedLrs)}
          onKeyDown={(e) => chkBoxNavigation(e, index < filteredData?.length ? `memoTablerowCheck${index + 1}` : 'memoTablerowCheck0', index === 0 ? 'memoExportPdfBtn' : `memoTablerowCheck${index - 1}`)}
        />
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
        <Box>
          <Typography>{data?.LRNO}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.ManualLRNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <div style={{ ...paymentTypeStyles, paddingLeft: 0 }} ><span style={{ backgroundColor: getPaymentTypeBackground(data?.PaymentType), padding: '4px 9px', borderRadius: '30px', textDecoration: data?.PaymentType?.length > 7 ? 'underline' : '' }} title={data?.PaymentType}>{data?.PaymentType}</span></div>
        </Box>
      </TableCell>
      {isGujaratCompany && (
        <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
          <Typography>{data?.DescriptionDet || ''}</Typography>
        </TableCell>
      )}
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.SourceCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.DestinationCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography style={{ padding: 0, display: 'block', textOverflow: 'ellipsis', textDecoration: data?.DestinationBranch?.length > 15 ? 'underline' : '', whiteSpace: 'nowrap', overflow: 'hidden', width: isGujaratCompany ? '100%' : '8vw' }} title={data.DestinationBranch} > {data.DestinationBranch}</Typography>
        </Box>
      </TableCell>
      {showSenderColumns && (
        <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
          <Box>
            <Typography>{data?.Sender}</Typography>
            <Typography>{data?.SenderMobileNo}</Typography>
          </Box>
        </TableCell>
      )}
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography style={{ padding: 0, display: 'block', textOverflow: 'ellipsis', textDecoration: data?.CurrentBranch?.length > 15 ? 'underline' : '', whiteSpace: 'nowrap', overflow: 'hidden', width: isGujaratCompany ? '100%' : '8vw' }} title={loginData.strBranchName} >{data?.CurrentBranch !== loginData.strBranchName ? loginData?.strBranchName : data?.CurrentBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data.ReceiptDate}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography style={{ textAlign: 'right' }}>{data.Units}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography style={{ textAlign: 'right' }}>{data.TotalDues}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <DropDownOA label={dm.branch || 'Branch'} data={branchListData || []} dataKey={`BranchName`} idKey={`BranchID`} listWidth={240} resetFlag={!bulkDeliveryCheck} onSelResetVal={true}
            value={delBranch?.BranchName || delBranch} defaultvalue={delBranch?.BranchName || delBranch} onSelect={(value) => { setBrnchForDelivery(value) }} disabled={isDisabled} noCross={true} />
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <DropDownOA label={dm.vehNo || 'Veh. No.'} data={vehicleList || []} listWidth={170} dataKey={`VehicleNo`} idKey={`VehicleID`} resetFlag={!bulkDeliveryCheck} onSelResetVal={true}
            value={transferVehicle?.VehicleNo || transferVehicle} defaultvalue={transferVehicle?.VehicleNo || transferVehicle} onSelect={(value) => setTrnsfrVehicle(value)} disabled={isDisabled} noCross={true} />
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <DropDownOA label={dm.driverName || 'Driver Name'} data={driverInfo || []} listWidth={170} dataKey={`DriverConductorName`} resetFlag={!bulkDeliveryCheck} onSelResetVal={true}
            idKey={`DriverConductorID`} value={transDriverName?.DriverConductorName || transDriverName} defaultvalue={transDriverName?.DriverConductorName || transDriverName} onSelect={(value) => { setDriverName(value) }} disabled={isDisabled} noCross={true} />
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <LineInputV3 style={{ textAlign: 'center' }} placeholder="Remark" value={remark || ''} onBlur={(e) => { setRemark(e.target.value) }} disabled={isDisabled} />
        </Box>
      </TableCell>
    </TableRow>
  )
}
export default DeliveryMemoTableTwo
